// extracted by mini-css-extract-plugin
export default {"form":"BI7Vtl","section":"RAI_8s","section-title":"yquPZT"};